import { useEffect, useRef, useState } from "react";
import { pagesDuSiteService, PageDuSite } from "../../services/pagesDuSiteService";
import ContentSkeleton from "../../composants/Skeleton/ContentSkeleton";
import "./PageStatique.css";

interface PageStatiqueProps {
  slug: string;
}

/**
 * Page legale / charte generique : lit le contenu HTML edite en back-office (pages_du_site) par
 * son slug et le rend. Remplace les anciens composants React en dur (MentionsLegales, CharteRSE,
 * CharteDeontologie, CharteAchatsDurables, Securite) afin que toute edition faite dans le BO soit
 * immediatement refletee sur le site (fin de la desynchronisation front / BO).
 */
export default function PageStatique({ slug }: PageStatiqueProps) {
  const [page, setPage] = useState<PageDuSite | null>(null);
  const [loading, setLoading] = useState(true);
  const [erreur, setErreur] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let actif = true;
    setLoading(true);
    setErreur(false);
    pagesDuSiteService
      .getPage(slug)
      .then((p) => { if (actif) setPage(p); })
      .catch(() => { if (actif) setErreur(true); })
      .finally(() => { if (actif) setLoading(false); });
    return () => { actif = false; };
  }, [slug]);

  // Les liens externes du contenu s'ouvrent dans un nouvel onglet (comportement du front en dur).
  useEffect(() => {
    const root = contentRef.current;
    if (!root) return;
    root.querySelectorAll<HTMLAnchorElement>('a[href^="http"]').forEach((a) => {
      a.target = "_blank";
      a.rel = "noopener noreferrer";
    });
  }, [page]);

  return (
    <div className="page-statique-page">
      <div className="page-statique-container">
        {loading ? (
          <ContentSkeleton variant="richtext" />
        ) : erreur ? (
          <p className="page-statique-erreur">Contenu momentanément indisponible. Veuillez réessayer plus tard.</p>
        ) : (
          <div
            ref={contentRef}
            className="page-statique-content"
            dangerouslySetInnerHTML={{ __html: page?.contenu ?? "" }}
          />
        )}
      </div>
    </div>
  );
}
